import React from 'react';
import { CommonStyle } from '@luckycart/xpn-types';

type StyleContextType = {
  setStyle: (style: CommonStyle) => void;
  style: CommonStyle | null;
};
export const StyleContext = React.createContext<StyleContextType>({
  setStyle: () => undefined as void,
  style: null,
});
